import { useState } from 'react'
import { PlusIcon, ChatCircleDotsIcon } from '@phosphor-icons/react'
import { ScoopButton, ScoopText, ScoopDialog, ScoopRow, ScoopColumn } from '../../../../ui'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../../../../router/routes'
import { WorkspaceBox } from '../../../Auth/CreateWorkspace/WorkspaceBox/WorkspaceBox'
import { useQueryClient } from '@tanstack/react-query'
import { useWorkspaceMetadata } from '../../../../../api/hooks/workspaceMetadata/useWorkspaceMetadata'
import styles from './AIFlow.module.scss'

export const AIFlow = ({ inboxID, onClose }) => {
    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const { workspaceMetadata, refetch } = useWorkspaceMetadata()
    const [checkedOption, setCheckedOption] = useState(null)

    const handleNext = () => {
        if (checkedOption === 0) {
            refetch().then(() => {
                // Find the created inbox from workspaceMetadata
                const createdInbox = workspaceMetadata?.inboxes?.find(
                    (inbox) => inbox.inboxID === inboxID
                )
                // Navigate to Insights with the inbox selected
                navigate(ROUTES.INSIGHTS, { state: { createdInbox, selectedTab: 'ask-ai' } })
            })
        } else {
            onClose()
            queryClient.removeQueries(['reportSeriesTable', inboxID])
        }
    }

    const handleClose = () => {
        if (checkedOption === null) return
        onClose()
        queryClient.removeQueries(['reportSeriesTable', inboxID])
    }

    const actions = (
        <ScoopRow className={styles.actionsContainer}>
            <ScoopButton disabled={checkedOption === null} onClick={handleNext}>
                Go
            </ScoopButton>
        </ScoopRow>
    )

    return (
        <>
            <ScoopDialog
                showCloseButton={false}
                onClose={handleClose}
                maxWidth={800}
                open={true}
                actions={actions}
                title={'Jumpstart your insights'}
            >
                <ScoopText className={styles.descriptionText}>
                    Instantly unlock the power of your data. Choose how you'd like to get started:
                </ScoopText>
                <ScoopColumn className={styles.optionsContainer}>
                    <ScoopRow className={styles.optionsRow}>
                        <WorkspaceBox
                            onClick={() => setCheckedOption(0)}
                            icon={<ChatCircleDotsIcon size={40} className={styles.optionIcon} />}
                            title={'Chat with your data'}
                            subtitle={
                                "Ask questions and let Scoop's AI chatbot explore your data for instant answers"
                            }
                            selected={checkedOption === 0}
                        />
                        <WorkspaceBox
                            onClick={() => setCheckedOption(1)}
                            icon={<PlusIcon size={40} className={styles.optionIcon} />}
                            title={'Start working freely'}
                            subtitle={'Explore data in your own way'}
                            selected={checkedOption === 1}
                        />
                    </ScoopRow>
                </ScoopColumn>
            </ScoopDialog>
        </>
    )
}
